import { IApplicationState } from '../../types/redux';

export const reliabilitySelector = (state: IApplicationState) => state.reliability;
